import Vue from 'vue'
import { remove } from 'lodash'
import { getTenantContextInstance as tenantCtx } from '@/plugins/tenant'

const STORAGE_ITEM = 'novti-search-columns'

const persistedSearch = JSON.parse(localStorage.getItem(STORAGE_ITEM)) ?? {}

/**
 * Resolves the active tenant id after tenant context has booted.
 *
 * @returns {string|null}
 */
const currentTenantId = () => tenantCtx()?.tenant?.id ?? null

export default {
  namespaced: true,
  state: {
    novtiSearch: {
      columns: persistedSearch.columns ?? {},
      filtersByTenant: persistedSearch.filtersByTenant ?? {},
    },
    shouldRetrigger: false,
    loading: true,
  },
  getters: {
    getTableColumns: state => resource => state.novtiSearch?.columns[resource] ?? [],
    getFilters: state => resource => {
      const tenant = currentTenantId()

      if (!tenant) {
        return {}
      }

      return state.novtiSearch?.filtersByTenant?.[tenant]?.[resource] ?? {}
    },
    shouldRetrigger: state => state.shouldRetrigger,
    isLoading: state => state.loading,
  },
  mutations: {
    SET_TABLE_COLUMNS(state, payload) {
      const { resource, columns } = payload

      Vue.set(state.novtiSearch.columns, resource, columns)

      localStorage.setItem(STORAGE_ITEM, JSON.stringify(state.novtiSearch))
    },
    REMOVE_TABLE_COLUMN(state, payload) {
      const { resource, column } = payload

      remove(state.novtiSearch.columns[resource], columnField => columnField.key === column.key)

      localStorage.setItem(STORAGE_ITEM, JSON.stringify(state.novtiSearch))
    },
    SET_FILTERS(state, payload) {
      const { resource, filters } = payload
      const tenant = currentTenantId()

      if (!tenant) {
        return
      }

      if (!state.novtiSearch.filtersByTenant) {
        Vue.set(state.novtiSearch, 'filtersByTenant', {})
      }

      if (!state.novtiSearch.filtersByTenant[tenant]) {
        Vue.set(state.novtiSearch.filtersByTenant, tenant, {})
      }

      Vue.set(state.novtiSearch.filtersByTenant[tenant], resource, filters)

      localStorage.setItem(STORAGE_ITEM, JSON.stringify(state.novtiSearch))
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    RETRIGGER(state) {
      state.shouldRetrigger = !state.shouldRetrigger
    },
  },
}
